import React from "react";
import {useSelector,useDispatch} from 'react-redux';
import {useEffect,useState} from 'react';
import LoginFrom from './components/loginForm';
import Footer from './components/common/footer';
import Brief from './components/brief';
import Dashboard from './components/dashboard'
import LoadBriefForm from './components/loadBriefForm';
import {getCustomStyle} from './utility';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {Box} from "@material-ui/core";
import {Route,useHistory} from 'react-router-dom';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import * as briefActions from './actions/briefActions';
import CssBaseline from '@material-ui/core/CssBaseline';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeading, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons' // don't forget, you must add it to "library.add" too


const graphikRegular = {
  fontFamily: 'Graphik',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    url(https://storage.googleapis.com/usetopic/assets/GraphikRegular.woff) format('woff2')
  `
};

const graphikBold = {
  fontFamily: 'Graphik',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
    url(https://storage.googleapis.com/usetopic/assets/GraphikBold.woff) format('woff2')
  `
};

const theme = createMuiTheme({
    typography: {
      fontFamily: 'Graphik, Arial',
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '@font-face': [graphikRegular, graphikBold],
        },
      },
      MuiPaper: {
        elevation1:{
          'box-shadow': '0px 2px 5px 0px #3838382e'
        }
      }
    },
    palette: {
      primary: {
        main: '#3f4b5b'
      },
    }
});


function App(props){
  const dispatch = useDispatch();
  const history = useHistory();
  const loggedInState = useSelector(state => state.user);
  const [bIsLoggedIn,setIsLoggedIn] = useState(loggedInState.isLoggedIn);
  const briefsState = useSelector(state => state.briefs);
  const [oBriefs,setBriefs] = useState(briefsState);
  const [snackbarState, setSnackbarState] = React.useState(false);
  const [snackBarMessage, setSnackBarMessage] = React.useState("");

  library.add(faHeading, faExternalLinkAlt);

  useEffect(() => {
    if(localStorage.aToken || bIsLoggedIn){
      dispatch(briefActions.getBrief(localStorage.aToken));
    }
  }, []);

  useEffect(() => {
    setBriefs(briefsState);
  }, [briefsState]);

  useEffect(() => {
    if(bIsLoggedIn){
      dispatch(briefActions.getBrief(localStorage.aToken));
    }else{
      history.push('/')
    }
  }, [bIsLoggedIn]);

  useEffect(() => {
    setIsLoggedIn(loggedInState.isLoggedIn);
  }, [loggedInState]);

  const openSnackbar = (message) => {
    setSnackBarMessage(message);
    setSnackbarState(true);
  }
    return(
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          {getCustomStyle("#sidebar")}
          <Box  style={{background:'rgb(249, 249, 249)',minHeight:'100%'}}>
            {(!loggedInState.isLoggedIn &&  !localStorage.aToken) ? 
            <Route exact path="/">
              <LoginFrom openSnackbar={openSnackbar}/>
            </Route>
            : 
            <Route exact path="/">
              <Dashboard Briefs={oBriefs}/>
            </Route>
            }
            <Route exact path="/brief/:id">
              <Brief Briefs={oBriefs}/>
            </Route>
            <Route exact path="/loadBrief">
              <LoadBriefForm/>
            </Route>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              open={snackbarState}
              autoHideDuration={6000}
              onClose={()=>(setSnackbarState(false))}
              message={snackBarMessage}
              action={
                <React.Fragment>
                  <IconButton size="small" aria-label="close" color="inherit" onClick={()=>(setSnackbarState(false))}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </React.Fragment>
              }
            />
          </Box>
          <Footer/>
      </MuiThemeProvider>
    );
}

export default App;
